import { Toggler } from '../components/Toggler';
import { Selector } from '../components/Selector';

/* selector */
const selectElemsArr = Array.from(document.querySelectorAll('.select'));
const selectorConfig = {
  selectorTplSel: '.selector-template',
  selectorWrapperSel: '.selector',
  selectorTogglerSel: '.selector__placeholder',
  selectorTitleSel: '.selector__title',
  selectorListClass: 'selector__list',
  selectorOptionClass: 'selector__option',
  selectorClassAvtive: 'selector_active',
};
selectElemsArr.forEach((selectElemsArrEl) => {
  const selector = new Selector(selectElemsArrEl, selectorConfig);
  selector.init();
});

/* toggler */
/*
const filterTogglerConfig = {
  targetForm: document.forms.filter,
  togglerSel: '.toggler_parent_filter',
  togglerHolderSel: '.filter-control__wrapper',
  togglerItemClass: 'filter-control__item',
  togglerBtnCloseClass: 'filter-control__close',
  togglerBtnRemoveSel: '.filter-control__reset',
};
const toggler = new Toggler(filterTogglerConfig);
toggler.setEventListeners();
*/